import React from "react";

const Header = props => {
  return (
    <h2 className="Header" onClick={props.updateHeader}>
      {props.currentTitle}
    </h2>
  );
};

export default Header;
